/// <reference path="../../types/global.d.ts" />

type MatchiI18nLocales = {
  [key in MatchiLocale]: I18nLocale;
};

const MATCHI_I18N_LOCALE_MAP: MatchiI18nLocales = {
  "en-GB": "en",
  "en-US": "en",
  "da-DK": "da",
  "de-DE": "de",
  "es-ES": "es",
  "fi-FI": "fi",
  "fr-FR": "fr",
  "hr-HR": "hr",
  "nb-NO": "no",
  "sv-SE": "sv",
  "nl-NL": "nl",
  "et-EE": "et",
  "lv-LV": "lv",
  "lt-LT": "lt",
};

type KeycloakI18nLocaleMap = {
  [key in KeycloakLocale]: I18nLocale;
};

const KEYCLOAK_I18N_LOCALE_MAP: KeycloakI18nLocaleMap = {
  en: "en",
  sv: "sv",
  da: "da",
  de: "de",
  es: "es",
  fi: "fi",
  fr: "fr",
  hr: "hr",
  no: "no",
  nl: "nl",
  et: "et",
  lv: "lv",
  lt: "lt",
};

type KeycloakMatchiLocaleMap = {
  [key in KeycloakLocale]: MatchiLocale;
};

const KEYCLOAK_MATCHI_LOCALE_MAP: KeycloakMatchiLocaleMap = {
  en: "en-GB",
  da: "da-DK",
  de: "de-DE",
  es: "es-ES",
  fi: "fi-FI",
  fr: "fr-FR",
  hr: "hr-HR",
  no: "nb-NO",
  sv: "sv-SE",
  nl: "nl-NL",
  et: "et-EE",
  lv: "lv-LV",
  lt: "lt-LT",
};

const DEFAULT_I18N_LOCALE = MATCHI_I18N_LOCALE_MAP["en-GB"];
const DEFAULT_MATCHI_LOCALE = KEYCLOAK_MATCHI_LOCALE_MAP["en"];

export const matchiToI18nLocale = (locale: MatchiLocale): I18nLocale =>
  MATCHI_I18N_LOCALE_MAP[locale] ?? DEFAULT_I18N_LOCALE;

export const keycloakToI18nLocale = (locale?: KeycloakLocale): I18nLocale => {
  if (!locale) return DEFAULT_I18N_LOCALE;
  return KEYCLOAK_I18N_LOCALE_MAP[locale] ?? DEFAULT_I18N_LOCALE;
};

export const i18nToMatchiLocale = (locale: string): MatchiLocale => {
  const entry = Object.entries(MATCHI_I18N_LOCALE_MAP).find(
    ([, i18n]) => i18n === locale,
  );
  return (entry?.[0] as MatchiLocale) ?? DEFAULT_MATCHI_LOCALE;
};

export const keycloakToMatchiLocale = (
  locale?: KeycloakLocale,
): MatchiLocale => {
  if (!locale) return DEFAULT_MATCHI_LOCALE;
  return KEYCLOAK_MATCHI_LOCALE_MAP[locale] ?? DEFAULT_MATCHI_LOCALE;
};
